__turbopack_context__.v({
  "actions": "t1IRuW_actions",
  "card": "t1IRuW_card",
  "preview": "t1IRuW_preview",
});
